var data = function() 
{    
    const apiUrl = 'https://localhost:5101/api/';

    var values = {
        gameweekDates: [],
        gameweekHistories: [],
        rows: [],
        picks: [],
        playedPicks: [],
        plannedPicks: [],
        players: [],
        teams: [],
        chips: [],
        gameweekChips: [],
        plannedChips: [],
        fplTeam: null,
        userId: 0
    };

    const newData = new CustomEvent("newData", {});

    async function loadData()
    {
        values.gameweekDates = localStorage.getItem("gameweekDates") == null ? [] : JSON.parse(localStorage.getItem("gameweekDates"));
        values.rows = localStorage.getItem("rows") == null ? [] : JSON.parse(localStorage.getItem("rows"));
        values.players = localStorage.getItem("players") == null ? [] : JSON.parse(localStorage.getItem("players"));
        values.teams = localStorage.getItem("teams") == null ? [] : JSON.parse(localStorage.getItem("teams"));
        values.fplTeam = localStorage.getItem("fplteam") == null ? null : JSON.parse(localStorage.getItem("fplteam"));
        values.plannedPicks = localStorage.getItem("plannedPicks") == null ? [] : JSON.parse(localStorage.getItem("plannedPicks"));
        values.playedPicks = localStorage.getItem("playedPicks") == null ? [] : JSON.parse(localStorage.getItem("playedPicks"));
        values.userId = localStorage.getItem("userId") == null ? 0 : JSON.parse(localStorage.getItem("userId"));
        values.gameweekHistories = localStorage.getItem("gameweekHistories") == null ? [] : JSON.parse(localStorage.getItem("gameweekHistories"));
        values.gameweekChips = localStorage.getItem("gameweekChips") == null ? [] : JSON.parse(localStorage.getItem("gameweekChips"));
        values.chips = localStorage.getItem("chips") == null ? [] : JSON.parse(localStorage.getItem("chips"));

        values.picks = [];

        for (let i = 1; i <= 38; i++)
        {
            var playedPicks = values.playedPicks.filter(p => p.gameweek == i);
            
            if (playedPicks.length > 0)
            {                
                playedPicks.forEach(p => {
                    values.picks.push(p);
                });
            }
            else 
            {            
                var plannedPicks = values.plannedPicks.filter(p => p.gameweek == i);
                
                if (plannedPicks.length > 0)
                {                
                    plannedPicks.forEach(p => {
                        values.picks.push(p);
                    });
                }
            }
        }

        console.log("values",
            values);
    }

    async function getPlannerData(fplTeamId, fplTeamName)
    {
        return await fetch(apiUrl + 'planner/getdata/' + fplTeamId  + '/')
            .then(response => {
                if (response.status == 200)
                {                    
                    return response.json();
                }
                else {
                    //
                }
            }).then((data) => {
                console.log(data);

                localStorage.setItem("fplteam", JSON.stringify({
                    "fplTeamId": fplTeamId,
                    "fplTeamName": fplTeamName
                }));

                localStorage.setItem("userId", 0);

                localStorage.setItem("teams", JSON.stringify(data.teams));
                values.teams = data.teams;

                localStorage.setItem("rows", JSON.stringify(data.rows));
                values.rows = data.rows;

                localStorage.setItem("players", JSON.stringify(data.players));
                values.players = data.players;

                localStorage.setItem("gameweekDates", JSON.stringify(data.gameweekDates));
                values.gameweekDates = data.gameweekDates;

                localStorage.setItem("gameweekHistories", JSON.stringify(data.gameweekHistories));
                values.gameweekHistories = data.gameweekHistories;

                localStorage.setItem("playedPicks", JSON.stringify(data.picks));
                values.playedPicks = data.picks;

                localStorage.setItem("gameweekChips", JSON.stringify(data.gameweekChips));
                values.gameweekChips = data.gameweekChips;

                localStorage.setItem("chips", JSON.stringify(data.chips));
                values.chips = data.chips;

                console.log("localStorage.getItem(plannedPicks)", localStorage.getItem("plannedPicks"));
                console.log("data.picks", data.picks);


                if (localStorage.getItem("userId") == 0 
                    && localStorage.getItem("plannedPicks") == null
                    && data.picks.length > 0)
                {
                    createDefaultPlannedPicks(data.picks);
                }
                
                document.dispatchEvent(newData);
            })
            .catch(err => {
                console.error('Error fetching data:', err);             
                //
            });
    }

    function createDefaultPlannedPicks(picks)
    {
        var plannedPicks = [];

        const latestGameweek = (picks.reduce((prev, current) => (prev && prev.gameweek > current.gameweek) ? prev : current)).gameweek;

        const latestPicks = picks.filter(p => p.gameweek == latestGameweek);

        console.log("latestGameweek", latestGameweek);
        console.log("latestPicks", latestPicks);

        var id = 1;

        if (latestGameweek != 38)
        {
            for (let i = (latestGameweek + 1); i <= 38; i++)  
            {
                latestPicks.forEach(p => {
                    plannedPicks.push({
                        "pickId": id++,
                        "gameweek": i,
                        "playerId": p.playerId,
                        "position": p.position,
                        "order": p.order,
                        "isCaptain": p.isCaptain,
                        "isViceCaptain": p.isViceCaptain,
                        "isPlanned": true,
                        "name": p.name,
                        "teamName": p.teamName,
                        "teamNameShort": p.teamNameShort,
                        "value": p.value,
                        "points": 0
                    });
                });
            }
        }
        
        localStorage.setItem("plannedPicks", JSON.stringify(plannedPicks));
    }

    async function setup(fplTeamId, fplTeamName)
    {
        return await fetch(apiUrl + 'planner/setup', 
                { 
                    method: 'POST', 
                    body: JSON.stringify({ id: fplTeamId, name: fplTeamName }), 
                    headers: { 'Content-Type': 'application/json' } 
                })
            .then(response => {
                if (response.status == 200)
                {                    
                    return response.json();
                }
                else {
                    return null;
                }
            }).then((x) => {
                console.log("x",x);
                getPlannerData(fplTeamId, fplTeamName);
            })
            .catch(err => {
                console.error('Error fetching data:', err);             
                return null;   
            });
    }

    async function updateFPLTeamPicks(fplTeamId, fplTeamName)
    {
        return await fetch(apiUrl + 'planner/update-picks/' + fplTeamId  + '/1/38/')
            .then(response => {
                if (response.status == 200)
                {                    
                    return response.json();
                }
                else {
                    return null;
                }
            }).then(() => {
                getPlannerData(fplTeamId, fplTeamName);
            })
            .catch(err => {
                console.error('Error fetching data:', err);             
                return null;   
            });
    }

    async function getFPLTeam(fplTeamId)
    {
        return await fetch(apiUrl + 'planner/fplteam/' + fplTeamId  + '/')
            .then(response => {
                if (response.status == 200)
                {                    
                    return response.json();
                }
                else {
                    return null;
                }
            })
            .catch(err => {
                console.error('Error fetching data:', err);             
                return null;   
            });
    }

    function getValues() {
        return values;
    }

    return {
        getValues: getValues,
        getFPLTeam: getFPLTeam,
        getPlannerData: getPlannerData,
        loadData: loadData,
        updateFPLTeamPicks: updateFPLTeamPicks,
        setup: setup
    };
}();

export { data }